const colorConvert = require('color-convert');
export function defaultValue(a, b) {
    if (a !== undefined && a !== null) {
        return a;
    }
    return b;
}
export function defined(a) {
    return a !== undefined;
}
export const getActivityColor = (i, n) => {
    const red = Math.floor(100 * Math.cos((2 * Math.PI * i) / n) + 150);
    const green = Math.floor(100 * Math.cos((2 * Math.PI * i) / n + 2.4) + 140);
    const blue = Math.floor(100 * Math.cos((2 * Math.PI * i) / n + 3.92) + 140);
    return `rgb(${[red, green, blue].join(',')})`;
};
export const stringSplitter = s => {
    let middle = Math.floor(s.length / 2);
    const before = s.lastIndexOf(' ', middle);
    const after = s.indexOf(' ', middle + 1);
    if (before === -1 || (after !== -1 && middle - before >= after - middle)) {
        middle = after;
    }
    else {
        middle = before;
    }
    return [s.substr(0, middle), s.substr(middle + 1)];
};
export const offsetPosition = (lat, lon, offsetDistance) => {
    // given a lat lon and offset, this will return  new lat lat lon for the position of the offset
    // Earth’s radius, sphere
    const R = 6378137;
    // Coordinate offsets in radians
    const dLat = offsetDistance / R;
    const dLon = offsetDistance / (R * Math.cos((Math.PI * lat) / 180));
    // OffsetPosition, decimal degrees
    return {
        lat: lat + (dLat * 180) / Math.PI,
        lon: lon + (dLon * 180) / Math.PI,
    };
};
export const ISOtoMicroseconds = ISOTime => new Date(ISOTime).getTime();
export const IsoToEpochTime = IsoTime => new Date(IsoTime).getTime();
export const convertToRadian = deg => (deg / 180) * Math.PI;
export const convertToRadians = p => (Object.assign(Object.assign({}, p), { latitude: convertToRadian(p.latitude), longitude: convertToRadian(p.longitude) }));
export const convertToDegrees = radian => (radian * 180.0) / Math.PI;
export const convertPoint = point => {
    const newPoint = convertToRadians(point);
    newPoint.time = ISOtoMicroseconds(point.time);
    return newPoint;
};
export const convertColor = color => {
    // was this passed in as a hex?
    if (color.search('#') === 0) {
        return `rgb(${colorConvert.hex.rgb(color.replace('#', '')).join(',')})`;
    }
    // as this passed in as rgb?
    if (color.search('rgb') === 0)
        return color.replace(/\s+/g, '');
    return color;
};
export const nameInitializer = (name, initializeType) => {
    switch (initializeType) {
        case 'initials':
            return name
                .split(/[\s-]/)
                .map(l => l[0])
                .join(' ');
        case 'initializeFirst':
            return name
                .split(/[\s]/)
                .map((l, i) => {
                if (i === 0)
                    return l[0];
                return l;
            })
                .join(' ');
        default:
            return name;
    }
};
export const checkWindow = () => typeof window !== 'undefined';
// Compares if 2 arrays are equal ( MUST BE IN SAME ORDER)
export const arraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }
    // Initialises the comparison as true and then changes it to false if difference is found.
    let comparison = true;
    // Loops throught comparing all elements and breaks setting false if elements are found different
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            comparison = false;
            break;
        }
    }
    return comparison;
};
export function computeDefaultSpeed(startPoint, endPoint, desiredLengthInMins) {
    const MS_TO_MINS = 1 / 1000 / 60;
    const defaultDefaultSpeed = 32;
    if (startPoint && endPoint) {
        const startDate = new Date(startPoint.time);
        const endDate = new Date(endPoint.time);
        const trackLengthInMins = Math.abs(endDate - startDate) * MS_TO_MINS;
        const idealMultiplier = trackLengthInMins / desiredLengthInMins;
        return Math.max(Math.pow(2, Math.round(Math.log2(idealMultiplier), 1)));
    }
    else {
        return defaultDefaultSpeed;
    }
}
export function isValidUrl(url) {
    try {
        const test = new URL(url);
        return test.protocol === 'http:' || test.protocol === 'https:';
    }
    catch (_) {
        return false;
    }
}
export function buildAssetUrl(filename) {
    /* eslint-disable */
    if (!window.AyvriViewerAssetPath)
        throw new Error('buildAssetUrl called before the asset path was set');
    return `${window.AyvriViewerAssetPath}/${filename}`;
    /* eslint-enable */
}
